import { createTheme } from "@material-ui/core/styles";
import { ptBR } from '@material-ui/core/locale';
import 'react-toastify/dist/ReactToastify.css';


export const theme = createTheme({
	palette: {
		primary: {
			main: "#343A40",
		},
		secondary: {
			main: "#EEEEEE",
		},
		background: {
			default: '#FFFFFF'
		}
	},
	typography: {
		fontFamily: "Poppins",
		fontSize: 14,
		body1: {
			fontSize: 12
		},
		body2: {
			fontSize: 12
		},
		caption: {
			fontSize: 12
		},
	},
	overrides: {
		MuiInputBase: {
			input: {
				WebkitBoxShadow: "0 0 0 30px white inset",
			},
		},
		MuiTooltip: {
			tooltip: {
				fontSize: "1.2rem",
			},
		},
		// MuiTableHead: {
		// 	root: {
		// 		background: 'white'
		// 	}
		// }
	},
}, ptBR);